import { render, staticRenderFns } from "./ElectricityReport.vue?vue&type=template&id=faf0a066&scoped=true&"
import script from "./ElectricityReport.vue?vue&type=script&lang=ts&"
export * from "./ElectricityReport.vue?vue&type=script&lang=ts&"
import style0 from "./ElectricityReport.vue?vue&type=style&index=0&id=faf0a066&lang=scss&scoped=true&"
import style1 from "./ElectricityReport.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faf0a066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCol,VIcon,VRow,VSimpleTable,VSpacer,VTooltip})
